export default {
  common: {
    title: 'Logistics Management System',
    confirm: 'Confirm',
    cancel: 'Cancel',
    submit: 'Submit',
    reset: 'Reset',
    search: 'Search',
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    back: 'Back',
    operation: 'Operation',
    status: 'Status',
    createTime: 'Create Time',
    updateTime: 'Update Time'
  },
  message: {
    success: 'Operation successful',
    error: 'Operation failed',
    warning: 'Warning',
    info: 'Info',
    confirmDelete: 'Are you sure to delete?'
  },
  login: {
    title: 'Login',
    username: 'Username',
    password: 'Password',
    loginBtn: 'Login'
  },
  language: {
    language: 'Language',
    german: 'German',
    english: 'English',
    chinese: 'Chinese',
    polish: 'Polish'
  },
  nav: {
    home: 'Home',
    about: 'About',
    services: 'Services',
    blog: 'Blog',
    contact: 'Contact'
  },
  banner: {
    title1: 'The Best Transportation Solution Worldwide',
    text1: 'Multiple international routes, direct air freight. Maximum logistics discounts, transparent fees, no hidden costs.',
    title2: 'The Best Transportation Solution Worldwide',
    text2: 'Through precise processes, efficiency is 30%-40% higher than competitors. Use as needed, expandable at any time, avoiding warehouse problems during peak season.',
    title3: 'Leading in Global Logistics Services',
    text3: 'Simplifying international trade.',
    requestQuote: 'Request Quote'
  },
  tracking: {
    placeholder: 'Please enter your logistics tracking number',
    query: 'Query',
    title: 'Logistics Information',
    noInfo: 'No Information',
    trackingNumber: 'Logistics Tracking Number',
    loading: 'Loading logistics data...',
    customerName: 'Recipient',
    mobile: 'Phone',
    address: 'Address',
    goodsName: 'Goods Name',
    timelineTitle: 'Logistics Progress'
  },
  services: {
    title: 'Services',
    subtitle: 'Service for Cross-Border E-Commerce Sellers',
    description: 'Don\'t worry about delivery, orders will be processed in time.',
    landTransport: 'Land Transport',
    landTransportDesc: 'Lowest discounts for international express, DHL, UPS and postal packages, enjoy the lowest discounts.',
    airFreight: 'Air Freight',
    airFreightDesc: 'Offers various direct air transport services to America, Europe, Japan and other regions.',
    warehouse: 'Warehouse',
    warehouseDesc: 'Free storage, one-time commission, storage, outbound, packaging and labeling.',
    seaFreight: 'Sea Freight',
    seaFreightDesc: 'Integration of high-quality international shipping resources from Hong Kong for worldwide navigation.',
    homeDelivery: 'Home Delivery',
    homeDeliveryDesc: 'You only need to pay a certain international logistics fee, we deliver your goods directly to your home.',
    support24x7: '24x7 Support',
    support24x7Desc: 'Years of experience in cross-border e-commerce service, 7*24 hours online customer service, timezone-free service.',
    readMore: 'Read More',
    bestServices: 'Our Best Services',
    bestServicesSubtitle: 'We serve businesses, shops and individuals engaged in cross-border e-commerce.',
    internationalShipping: 'International Shipping',
    internationalShippingDesc: 'Largest discount on international logistics costs, can help you save logistics costs.',
    packageProtection: 'Package Protection',
    packageProtectionDesc: 'Dropshipping, sorting and packaging, printing and order labeling, saving personnel costs.',
    freightSupport: 'Freight Support',
    freightSupportDesc: 'Freight Support',
    onTimeDelivery: 'On-Time Delivery',
    onTimeDeliveryDesc: '30% - 40% Higher operational efficiency than competitors, low error rate and perfect user experience.',
    logisticsWork: 'Logistics Work',
    logisticsWorkDesc: 'Free API for effective management of warehouse information, product information, order information and logistics information.',
    supportDesc: 'On-demand use of warehouse space helps you avoid the problems of empty warehouses in the off-season and overcrowded warehouses in the peak season.',
    exploreAll: 'Explore All Services'
  },
  about: {
    title: 'About Us',
    mainTitle: 'Digital and Trustworthy Transportation Company',
    description: 'GG is a new warehouse service model specifically developed for export-oriented e-commerce, based on Internet management.',
    point1: 'Customers bring goods in batches to the cloud warehouse;',
    point2: 'GG sorts, packages, prints and labels goods directly from the cloud warehouse based on sales orders and conducts transportation and distribution;',
    description2: 'GG Enterprise Cloud Warehouse is a comprehensive supply chain service that integrates warehouse management, international transportation, overseas customs clearance and information management. It can help customers break through warehouse and logistics bottlenecks, save costs, increase customer satisfaction and explore overseas markets.',
    experience: 'We have more than years of experience',
    readMore: 'Read More',
    contact: 'Contact'
  },
  choose: {
    title: 'Why Choose Us',
    mainTitle: 'We Provide Fast, Better Solutions for Transportation',
    description: 'Global Goods Enterprise Cloud Warehouse is a new warehouse service model specifically developed for export-oriented e-commerce, based on Internet management. It can provide a complete solution for foreign trade e-commerce including warehousing, sorting and packaging, document printing and labeling, international logistics, overseas distribution, etc., while enjoying ultra-low international shipping costs. Helps customers break through warehouse and logistics bottlenecks, save costs, increase customer satisfaction and explore overseas markets.',
    internationalShipping: 'International Shipping',
    packageProtection: 'Package Protection',
    homeDelivery: 'Home Delivery',
    deliveryTime: 'Delivery Time',
    contact: 'Contact'
  },
  team: {
    title: 'Our Team',
    description: 'Everyone says this, but in our case it\'s true: Our team is the secret to our success. Every employee is excellent, but together they are the key to making Rostrum such an interesting and valuable workplace. The Rostrum team is a closely connected, talented team with a shared vision of continuously delivering outstanding results for customers while ensuring the company is an entertaining, inclusive, challenging workplace and developing careers with rich rewards.',
    follow: 'Follow'
  },
  gallery: {
    title: 'Our Gallery',
    description: 'Global Goods conducts extensive business activities worldwide, with its six business areas, one initiative and regional organizations working closely together worldwide. Through strategic and organic integration of our solid business foundation and diverse, high-level functions, we create new value by proactively addressing changes and transcending existing frameworks to help solve social problems.',
    all: 'All',
    airFreight: 'Air Freight',
    waterFreight: 'Water Freight',
    shipping: 'Shipping',
    shippingTitle: 'Shipping',
    expertTeam: 'Expert Team',
    expertMember: 'Expert Member',
    carTransport: 'Car Transport',
    seaport: 'Seaport',
    container: 'Container',
    packaging: 'Packaging'
  },
  funfact: {
    productDelivery: 'Product Delivery',
    totalBranches: 'Total Branches',
    satisfiedCustomers: 'Satisfied Customers',
    ownVehicles: 'Own Vehicles'
  },
  blog: {
    title: 'Latest News & Blog',
    description: 'Find the latest blog news from WIRED. See related articles, photos, slideshows and videos.',
    readMore: 'Read More',
    comments: 'Comments',
    title1: 'Air Freight Can Become Expensive During the Pandemic',
    excerpt1: 'Drastically reduced shipping capacity and urgent demand for protective equipment have driven up prices for air freight services...',
    title2: 'New Freight Service Opens in Global Market',
    excerpt2: 'At the top of this market, global freight forwarders must commit to maintaining a flexible attitude in transporting goods. Stay open to new things...',
    title3: 'Transportation Fees Have Been Removed From',
    excerpt3: 'Due to the direct impact of transportation on economic success, governments are traditionally more involved in freight forwarders\' practices than in most cases...'
  },
  transport: {
    title: 'Transport',
    mainTitle: 'Bring Your Goods Anywhere',
    description: 'Reference Time Limit: Refers to the normal transportation time of goods. That is, based on big data calculations, most packages may be delayed due to weather, customs inspections, port congestion, logistics warehouse explosions and other problems, from network access query time to arrival of goods at destination. The specific situation is subject to actual transportation.',
    requestQuote: 'Request Quote',
    formTitle: 'Request Quote',
    name: 'Name',
    request: 'Request Quote',
    length: 'Length (CM)',
    width: 'Width (CM)',
    weight: 'Weight (KG)',
    distance: 'Distance (KM)',
    city: 'City',
    transportType: 'Transport Type',
    airFreight: 'Air Freight',
    roadTransport: 'Road Transport',
    railTransport: 'Rail Transport',
    seaFreight: 'Sea Freight',
    submit: 'Submit Now',
    contact: 'Contact'
  },
  newsletter: {
    title: 'Stay Updated with Our Latest Newsletter',
    placeholder: 'Please enter your email address',
    subscribe: 'Subscribe'
  },
  footer: {
    followUs: 'Follow Us',
    quickLinks: 'Quick Links',
    about: 'About',
    services: 'Services',
    currentWork: 'Current Work',
    expertTeam: 'Expert Team',
    newsBlog: 'News & Blogs',
    support: 'Support',
    faqs: 'FAQs',
    pricing: 'Pricing',
    privacyPolicy: 'Privacy Policy',
    terms: 'Terms & Conditions',
    globalLocations: 'Global Locations',
    partners: 'Our Partners',
    copyright: 'Copyright @2024 fairy. Designed By',
    menu: 'Menu'
  }
}
